export default __webpack_public_path__ + "static/media/UsingFog.50a52450.mp4";